import Vue from 'vue';
import * as C from '../constants';

export default {

  /**
   * Sets session info in state.
   *
   * @param state
   * @param payload
   */
  [C.APP_SESSION_INFO_SET](state, { user, brands, products, suppliers }) {
    Vue.set(state, 'auth', {
      ...state.auth,
      user,
      brands,
      products,
      suppliers,
      session: true,
    });
  },

  /**
   * @param state
   */
  [C.APP_DOMAINS_PENDING](state) {
    Vue.set(state, 'domains', {
      loading: true,
      error: null,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.APP_DOMAINS_SUCCESS](state, payload) {
    Vue.set(state, 'domains', {
      loading: false,
      error: null,
      items: payload,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.APP_DOMAINS_PENDING](state, payload) {
    Vue.set(state, 'domains', {
      loading: false,
      error: payload,
      items: [],
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js